import { ElectionsType } from '@hooks/useElections';

export const modifiedElectionScheduleId = (elections: ElectionsType[]) => {
  return elections.map((election: ElectionsType) => {
    return {
      label: election.election_name_bn,
      value: election.election_schedule_id,
    };
  });
};
